import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {User} from "../../models";
import {first} from "rxjs/operators";
import {CardService} from "../../services/card.service";

@Component({
    selector: 'change-number-form-dialog',
    templateUrl: './changeNumberDialog.component.html',
    styleUrls: ['./changeNumberDialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ChangeNumberDialogComponent {
    action: string;
    customer: User;
    numberForm: FormGroup;
    dialogTitle: string;
    cardExists = true;
    cardNumber: string = '';
    checkingCardNumber = false;

    constructor(
        public matDialogRef: MatDialogRef<ChangeNumberDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        private cardService: CardService
    ) {
        this.translationLoader.loadTranslations(polish);
        // Set the defaults
        this.action = _data.action;


        this.numberForm = this.createNumberForm();
    }

    createNumberForm(): FormGroup {
        return this._formBuilder.group({
            number: ['', Validators.required],
        });
    }

    verifyCardNumber(event: any) {
        this.cardNumber = event.target.value;
        this.checkingCardNumber = true;
        this.cardService.getByNumber(event.target.value).pipe(first())
            .subscribe(data => {
                this.cardExists = true;
                this.checkingCardNumber = false;
            }, error => {
                this.cardExists = false;
                this.checkingCardNumber = false;
            });
    }
}
